module.exports = __webpack_public_path__ + "dd411c8b8f7392b029451f1256cf9717.pdf";